/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { fetchData } from '@jda/lui-portal-utilities';
import { getAuthToken } from '../auth/authProvider';
import { createRequestObject, getAPIMUrl } from '../utility/commonUtility';

const { ENTITLEMENT_SERVICE } = window['env'];

export const getAllOrganizations = async () => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${ENTITLEMENT_SERVICE}/organizations`;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((data) => {
      return data;
    })
    .catch((error: any) => {
      throw error.response.data.message;
    });
};

export const getAllApplicationsForOrg = async (orgName: string) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${ENTITLEMENT_SERVICE}/applications?org-name=${orgName}`;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error.response.data.message;
    });
};

export const getAllModulesForApp = async (name: string) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${ENTITLEMENT_SERVICE}/modules?app-name=${name}`;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error.response.data.message;
    });
};

export const getModuleById = async (moduleId: number) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${ENTITLEMENT_SERVICE}/modules/${moduleId}`;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .catch((error: any) => {
      throw error.response.data.message;
    });
};
